export default __webpack_public_path__ + "static/media/3536 knife block B top.17825beb.png";